import { createReducer } from '@reduxjs/toolkit';
import { ListingModel, PartnerListingModel } from './ListingModels';
import {
  loadingListingsAction,
  storeListingAction,
  storeListingsAction,
  storePartnerListingsAction,
} from './ListingsActionCreators';

export interface ListingsReducerState {
  listings: ListingModel[];
  loading: boolean;
  listing: ListingModel | undefined;
  partnerListings: PartnerListingModel[];
}

export const initialState: ListingsReducerState = {
  listings: [],
  loading: false,
  listing: undefined,
  partnerListings: [],
};

export const listingsReducer = createReducer(initialState, (builder) => {
  builder.addCase(storeListingsAction, (state, action) => {
    state.listings = action.payload;
    state.loading = false;
  });
  builder.addCase(storeListingAction, (state, action) => {
    state.listing = action.payload;
    state.loading = false;
  });
  builder.addCase(storePartnerListingsAction, (state, action) => {
    state.partnerListings = action.payload;
    state.loading = false;
  });
  builder.addCase(loadingListingsAction, (state, action) => {
    state.loading = action.payload;
  });
});
